import moment from 'moment';
import { DATE_SETTINGS } from 'config';

// Transform time string (e.g "07:20") to seconds
export default timeStr => (timeStr
  ? moment.duration(timeStr, DATE_SETTINGS.HOURS_MINUTES_SECONDS).asSeconds()
  : 0
);
